import type { ValidationError } from './types'
import type { Datenbeschreibung } from '@/types/studyTypes'

export function validateDatenbeschreibung(d: Datenbeschreibung): ValidationError[] {
  const errors: ValidationError[] = []

  if (!d.artDerDaten?.length)
    errors.push({ field: 'artDerDaten', message: 'Bitte mindestens eine Datenart wählen.' })

  if (d.artDerDaten?.includes('biometrischeDaten') && !d.artDerBiometrischenDaten?.trim())
    errors.push({
      field: 'artDerBiometrischenDaten',
      message: 'Beschreibung biometrischer Daten ist erforderlich.',
    })

  if (d.artDerDaten?.includes('gesundheitsDaten') && !d.artDerGesundheitsDaten?.trim())
    errors.push({
      field: 'artDerGesundheitsDaten',
      message: 'Beschreibung der Gesundheitsdaten ist erforderlich.',
    })

  if (d.artDerDaten?.includes('sonstige') && !d.artDerDatenSonstige?.trim())
    errors.push({
      field: 'artDerDatenSonstige',
      message: 'Beschreibung sonstiger Daten ist erforderlich.',
    })

  return errors
}
